import { apiClient, assertOk } from "@/api/generated/client.ts"

import type { DataPointRequest } from "../types/dataPointDTOs.ts"

export const updateDataPoint = async (id: number, dataPoint: DataPointRequest) => {
  const { error, response } = await apiClient.PUT("/api/DataPoints/{id}", {
    params: { path: { id } },
    body: dataPoint,
    parseAs: "text",
  })
  assertOk(response, error)
}
